import React, { useContext } from "react";

//Material UI stuff
import TableRow from "@material-ui/core/TableRow";

//styling
import "./clusterRow.css";

//components
import ClusterRowInfoState from "./ClusterRowInfoState";
import ClusterRowInfoConnect from "./ClusterRowInfoConnect";
import ClusterRowInfoDelete from "./ClusterRowInfoDelete";
import ClusterRowInfoId from "./ClusterRowInfoId";
import ClusterRowInfoModule from "./ClusterRowInfoModule";
import ClusterRowInfoTier from "./ClusterRowInfoTier";
import ClusterRowInfoAuthentication from "./ClusterRowInfoAuthentication";
import ClusterRowInfoExpires from "./ClusterRowInfoExpires";
import DeleteClusterModal from "../../components/console/GeneralModal";

//access history
import { useHistory } from "react-router-dom";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

//helper functions
import { deleteIndividualCluster } from "./helpers";

const ClusterViewDesktopRowContent = ({
  clusterInfo,
  setIsDeleteModalOpen,
  isDeleteModalOpen,
  clusters,
  setClusters,
}) => {
  //access global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  //to use history
  const history = useHistory();

  //closes the modal
  const closeModal = () => {
    setIsDeleteModalOpen(false);
  };

  //function run when user confirms that cluster should be deleted. Makes API call
  const deleteCluster = () => {
    closeModal();

    deleteIndividualCluster(
      setClusters,
      clusters,
      clusterInfo,
      history,
      state,
      setState
    );
  };

  return (
    <>
      <TableRow>
        <ClusterRowInfoState clusterInfo={clusterInfo} />
        <ClusterRowInfoId clusterInfo={clusterInfo} />
        <ClusterRowInfoModule clusterInfo={clusterInfo} />
        <ClusterRowInfoTier clusterInfo={clusterInfo} />
        <ClusterRowInfoAuthentication clusterInfo={clusterInfo} />
        <ClusterRowInfoExpires clusterInfo={clusterInfo} />
        <ClusterRowInfoConnect clusterInfo={clusterInfo} />
        <ClusterRowInfoDelete setIsDeleteModalOpen={setIsDeleteModalOpen} />
      </TableRow>

      <DeleteClusterModal
        title="Delete Cluster?"
        text={`Cluster ${clusterInfo.data.id} will be permanently deleted.`}
        actionText="Delete"
        modalDescription="delete WCS cluster modal dialog"
        actionFunction={deleteCluster}
        cancelText="Cancel"
        cancelFunction={closeModal}
        open={isDeleteModalOpen}
        closeModal={closeModal}
        id="deleteClusterModal"
        actionButtonId="deleteClusterModalButton"
      />
    </>
  );
};

export default ClusterViewDesktopRowContent;
